export default __webpack_public_path__ + "static/media/reader.d57d2ae4.png";